import { render } from "./Confirmar.vue?vue&type=template&id=f4b3cac4&scoped=true"
import script from "./Confirmar.vue?vue&type=script&lang=js"
export * from "./Confirmar.vue?vue&type=script&lang=js"

import "./Confirmar.vue?vue&type=style&index=0&id=f4b3cac4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4b3cac4"]])

export default __exports__